/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Done_Unavailable_HInputs */

const en_funnel_done_unavailable_h = /** @type {(inputs: Funnel_Done_Unavailable_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This account can't start that trial.`)
};

const es_funnel_done_unavailable_h = /** @type {(inputs: Funnel_Done_Unavailable_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta cuenta no puede empezar esa prueba.`)
};

/**
* | output |
* | --- |
* | "This account can't start that trial." |
*
* @param {Funnel_Done_Unavailable_HInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_done_unavailable_h = /** @type {((inputs?: Funnel_Done_Unavailable_HInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Done_Unavailable_HInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_done_unavailable_h(inputs)
	return en_funnel_done_unavailable_h(inputs)
});